import { render, staticRenderFns } from "./PaymentFree.vue?vue&type=template&id=518c4769&"
import script from "./PaymentFree.vue?vue&type=script&lang=js&"
export * from "./PaymentFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports